import PropTypes from 'prop-types';
import styles from './loader.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function Loader({
  title
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.loaderIcon
    }), title && /*#__PURE__*/_jsx("p", {
      className: styles.title,
      children: title
    })]
  });
}
Loader.propTypes = {
  title: PropTypes.string
};